import apiClient from '@/services/rest-api-sms/apiClient'

const baseEndpoint = '/file'

export const upload = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}/upload`,
    data,
  })
  return response
}

export const getByUrl = async (urlPath) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/download`,
    params: {
      url: urlPath,
    },
  })

  return response
}
